import { useContext } from 'react';

import AuthContext from '@/context/auth/auth-context';

const useAuth = () => {
  const context = useContext(AuthContext);

  if (context === null) {
    throw new Error('useAuth must be used within an AuthContextProvider');
  }

  return context;
};

export default useAuth;
